import { ClientOnly } from '@go-beyond/react'
import { SignInLoadingState, SignInWidget } from '../../components/sign-in-widget.js'
import '../site.css'

export default function SignInPage() {
  return (
    <main className="auth-shell auth-shell--widget">
      <ClientOnly fallback={<SignInLoadingState />}>
        <SignInWidget />
      </ClientOnly>
    </main>
  )
}
